import React from 'react';

const AndConnector = () => {
  return (
    <div className="aud-v2-and-connector">
      <div className="aud-v2-and-connector__line" />
      <span className="aud-v2-and-connector__badge">AND</span>
    </div>
  );
};

export default AndConnector;
